import {Column} from 'react-table'
import {DataErItem} from '../../core/_models'
import {ErCustomHeader} from './ErCustomHeader'
import {ErItemValue} from './ErItemValue'
import {ErItemEmployee} from './ErItemEmployee'
import {ErItemDuration} from './ErItemDuration'

const ErColumns: Column<DataErItem>[] = [
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='Сотрудники' className='min-w-250px text-warning' />,
    accessor: 'extension',
    Cell: ({...props}) => <ErItemEmployee data={props.data[props.row.index].extension} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='Всего' className='min-w-125px text-gray-700' />,
    accessor: 'total',
    Cell: ({...props}) => <ErItemValue data={props.data[props.row.index].total} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='Входящие' className='min-w-125px text-primary' />,
    accessor: 'inbound',
    Cell: ({...props}) => <ErItemValue data={props.data[props.row.index].inbound} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='Исходящие' className='min-w-125px text-success' />,
    accessor: 'outbound',
    Cell: ({...props}) => <ErItemValue data={props.data[props.row.index].outbound} />,
  },
  {
    Header: (props) => (
      <ErCustomHeader tableProps={props} title='Средняя длительность' className='min-w-125px text-info' />
    ),
    accessor: 'avg_duration',
    Cell: ({...props}) => <ErItemDuration data={props.data[props.row.index].avg_duration} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='длительность вх' className='min-w-125px text-info' />,
    accessor: 'sum_inbound_duration',
    Cell: ({...props}) => <ErItemDuration data={props.data[props.row.index].sum_inbound_duration} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='длительность исх' className='min-w-125px text-info' />,
    accessor: 'sum_outbound_duration',
    Cell: ({...props}) => <ErItemDuration data={props.data[props.row.index].sum_outbound_duration} />,
  },
  {
    Header: (props) => <ErCustomHeader tableProps={props} title='вх + исх' className='min-w-125px text-info' />,
    accessor: 'sum_total_duration',
    Cell: ({...props}) => <ErItemDuration data={props.data[props.row.index].sum_total_duration} />,
  },
]

export {ErColumns}
